import React from 'react';
import { ConditionDatesForm, SelectPriceRoundingCondition } from '@retail/calculus/components';
import { Stack } from '@mui/material';
import { useSelectedOrgUnit, useUserBrands } from '@retail/app/stores/selected-context';
import { useFetchPriceRoundingRules } from '@retail/rounding/data-access';
import { RetailTanstackQueryLoadingWrapper } from '@retail/components';
import { PriceRoundingRuleConfig } from '@retail/rounding/types';
import { brandLogo } from '@retail/utils';

export const CreatePriceRoundingConditionContent: React.FC = () => {
  const { assortmentId } = useSelectedOrgUnit();
  const { selectedBrand } = useUserBrands();

  const loadingState = useFetchPriceRoundingRules({ assortmentId, suspense: false });

  return (
    <RetailTanstackQueryLoadingWrapper loadingState={loadingState}>
      {(priceRoundingRules) => (
        <Stack px={3} gap={2}>
          <SelectPriceRoundingCondition
            priceRoundingRuleConfigs={priceRoundingRules.map((dto) =>
              PriceRoundingRuleConfig.fromDto(dto, {
                name: selectedBrand.name,
                id: selectedBrand.brandId,
                imgUrl: brandLogo(selectedBrand.brandId).logo,
              })
            )}
          />
          <ConditionDatesForm alignment="column" labelAlignment="column" excludeToDate />
        </Stack>
      )}
    </RetailTanstackQueryLoadingWrapper>
  );
};
